import type { DateRange } from "@pentacode/core";
import { dateAdd, getPayrollPeriod, lastDayOfPreviousMonth } from "@pentacode/core";

export function getRangesForLocalResultCalculation(
    { from, to }: DateRange,
    startPayrollPeriod: number
): {
    timeEntries: DateRange;
    prevDailyResults: DateRange;
} {
    const timeEntriesFrom = getPayrollPeriod(from, startPayrollPeriod).from;

    const thirteenWeeksAgo = dateAdd(from, { weeks: -13 });
    // Daily Results require the last day of the previous month to properly calculate absence day durations
    const dailyResultsFrom = lastDayOfPreviousMonth(thirteenWeeksAgo);

    return {
        timeEntries: { from: timeEntriesFrom, to },
        prevDailyResults: { from: dailyResultsFrom, to: from },
    };
}
